import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import iconActiveMenu from "../../../../../assets/images/Event-2024/Frame 25.png";
import iconActiveMenuActive from "../../../../../assets/images/Event-2024/Rectangle (2).png";
import {
  TAB_EVENT_FINISHED_NEW_YEAR,
  TAB_EVENT_NEW_YEAR,
} from "../../../../../helper/const";
import { useNavigate, useParams } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import PATH from "../../../../../config/PATH";
import bgMobileActive from "../../../../../assets/images/Event-2024/Rectangle (3).png";
import bgMobile from "../../../../../assets/images/Event-2024/Frame 25 (1).png";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export default function Menu({ statusEvent }) {
  const { id } = useParams();
  const swiperRef = useRef(null);
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 567);
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setIsBeginning] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 420);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSlideChange = (swiper) => {
    setIsEnd(swiper.isEnd);
    setIsBeginning(swiper.isBeginning);
  };

  const postionItemMenuActive = useMemo(() => {
    let postionItemActive = 0;

    TAB_EVENT_NEW_YEAR.forEach((item, index) => {
      if (item.id === id) {
        postionItemActive = index;
      }
    });

    return postionItemActive;
  }, [id]);

  const dataEventActive = useMemo(() => {
    if (!statusEvent?.is_finished) {
      return TAB_EVENT_NEW_YEAR;
    }

    return TAB_EVENT_FINISHED_NEW_YEAR;
  }, [statusEvent]);

  const handChangeTab = (id) => {
    navigate(`${PATH.EVENT_NEW_YEAR_CHRISTMAS}/${id}`);
  };

  const handleNext = () => {
    swiperRef.current.swiper.slideNext();
  };

  const handlePrev = () => {
    swiperRef.current.swiper.slidePrev();
  };

  return (
    <Div>
      <div className="container-menu-event-2024">
        {dataEventActive.map((item) => {
          const isTabActive = item.id === id;
          return (
            <div
              key={item.id}
              className={`position-relative ${
                isTabActive ? "" : "tab-event-head"
              }`}
              onClick={() => handChangeTab(item.id)}
            >
              <img
                src={isTabActive ? iconActiveMenuActive : iconActiveMenu}
                alt=""
              />
              <div className="menu-event-new-year-2024">{item.title}</div>
            </div>
          );
        })}
      </div>
      <div className="mobile-header">
        <Swiper
          ref={swiperRef}
          slidesPerView={isSmallScreen ? 2 : 2.5} // Hiển thị total slide mỗi lần
          spaceBetween={0} // Khoảng cách giữa các slide
          speed={500} // Tốc độ chuyển slide
          freeMode={true} // Cho phép trượt tự do theo lực vuốt
          freeModeMomentum={true} // Đà vuốt, giúp cảm giác mượt mà
          pagination={{ clickable: false }} // Chấm điều hướng
          onSlideChange={handleSlideChange}
          initialSlide={postionItemMenuActive}
        >
          {dataEventActive.map((item) => {
            const isTabActive = item.id === id;
            return (
              <SwiperSlide key={item.id}>
                <div
                  className={`header-event_item ${
                    item.id === id ? "header-evernt_item__active" : ""
                  }`}
                  onClick={() => handChangeTab(item.id)}
                >
                  <img
                    src={isTabActive ? bgMobileActive : bgMobile}
                    className="bg-header-event"
                    alt=""
                  />
                  <div className="menu-event-new-year-2024">{item.title}</div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        {!isBeginning ? (
          <button
            onClick={handlePrev}
            className="btn-custom-event custom-prev-event"
          >
            <LeftOutlined />
          </button>
        ) : null}
        {!isEnd ? (
          <button
            onClick={handleNext}
            className="btn-custom-event custom-next-event"
          >
            <RightOutlined />
          </button>
        ) : null}
      </div>
    </Div>
  );
}

const Div = styled.div`
  position: relative;
  width: 100%;
  padding: 0 20px;
  height: 74px;

  .mobile-header {
    display: none;
  }

  .header-event_item {
    position: relative;
  }

  .tab-event-head {
    cursor: pointer;
  }

  .menu-event-new-year-2024 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
  }
  .container-menu-event-2024 {
    display: flex;
    gap: 20px;

    justify-content: center;
  }

  .icon-menu-head {
    width: 100%;
    position: absolute;
  }

  @media (min-width: 992px) {
    .tab-event-head:hover {
      scale: 1.05;
      transition: 0.3s ease-in-out;
    }
  }

  .custom-next-event {
    right: -12px;
  }

  .custom-prev-event {
    left: -12px;
  }
  .btn-custom-event {
    position: absolute;
    z-index: 2;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    border: 0px;
    background: #f97a1c;
    width: 24px;
    height: 24px;
    display: flex;
    gap: 15px;
    justify-content: center;
    align-items: center;

    svg {
      color: white;
    }
  }

  @media (max-width: 1400px) {
    padding: 0;
    height: 60px;
    .menu-event-new-year-2024 {
      font-size: 16px;
    }
    .container-menu-event-2024 {
      gap: 15px;
      height: 60px;
      .position-relative {
        width: 100%;
      }
      img {
        width: 100%;
        height: 60px;
      }
    }
  }

  @media (max-width: 1200px) {
    .container-menu-event-2024 {
      gap: 10px;
    }

    .menu-event-new-year-2024 {
      font-size: 14px;
    }
  }

  @media (max-width: 576px) {
    padding: 0;
    height: 50px;
    margin-top: 10px;

    .mobile-header {
      display: block;
    }
    .bg-header-event {
      height: 50px;
      width: 100%;
    }
    .swiper-wrapper {
      height: 100%;
    }

    .container-menu-event-2024 {
      display: none;
    }
  }
`;
